import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatCurrency } from './formatters';

export const generateInvoicePDF = (invoice, client, businessInfo) => {
  const doc = new jsPDF();

  // Header
  doc.setFontSize(20);
  doc.setFont(undefined, 'bold');
  doc.text('INVOICE', 105, 20, { align: 'center' });

  // Business info (From)
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(businessInfo.name || 'Your Business', 20, 40);
  doc.text(businessInfo.email || '', 20, 45);

  // Bill To
  doc.setFont(undefined, 'bold');
  doc.text('Bill To:', 20, 60);
  doc.setFont(undefined, 'normal');
  doc.text(client.name, 20, 65);
  if (client.company) doc.text(client.company, 20, 70);
  doc.text(client.email, 20, client.company ? 75 : 70);
  if (client.address) doc.text(client.address, 20, client.company ? 80 : 75);

  // Invoice details (right side)
  doc.setFont(undefined, 'bold');
  doc.text(`Invoice #: ${invoice.invoice_number}`, 120, 60);
  doc.setFont(undefined, 'normal');
  doc.text(`Date: ${invoice.issue_date}`, 120, 65);
  doc.text(`Due Date: ${invoice.due_date}`, 120, 70);
  doc.text(`Status: ${invoice.status.toUpperCase()}`, 120, 75);
  doc.text(`Currency: ${invoice.currency}`, 120, 80);

  // Items table — use autoTable(doc, options) pattern (jspdf-autotable v3+)
  const tableData = invoice.items.map(item => [
    item.description,
    item.quantity.toString(),
    formatCurrency(item.unit_price, invoice.currency),
    formatCurrency(item.amount, invoice.currency)
  ]);

  autoTable(doc, {
    startY: 95,
    head: [['Description', 'Quantity', 'Unit Price', 'Amount']],
    body: tableData,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [79, 70, 229] }, // indigo-600
    columnStyles: {
      0: { cellWidth: 80 },
      1: { halign: 'center' },
      2: { halign: 'right' },
      3: { halign: 'right' },
    },
  });

  const finalY = doc.lastAutoTable.finalY + 10;

  // Totals
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(`Subtotal: ${formatCurrency(invoice.subtotal, invoice.currency)}`, 150, finalY, { align: 'right' });
  doc.text(`Tax (${invoice.tax}%): ${formatCurrency(invoice.subtotal * invoice.tax / 100, invoice.currency)}`, 150, finalY + 6, { align: 'right' });

  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text(`Total: ${formatCurrency(invoice.total, invoice.currency)}`, 150, finalY + 14, { align: 'right' });

  // Notes
  if (invoice.notes) {
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text('Notes:', 20, finalY + 25);
    doc.text(invoice.notes, 20, finalY + 31, { maxWidth: 170 });
  }

  // Footer
  doc.setFontSize(8);
  doc.setTextColor(150);
  doc.text('Generated by InvoiceFlow', 105, 285, { align: 'center' });

  return doc;
};

export const downloadInvoicePDF = (invoice, client, businessInfo) => {
  const doc = generateInvoicePDF(invoice, client, businessInfo);
  doc.save(`invoice_${invoice.invoice_number}.pdf`);
};

export const getInvoicePDFBlob = (invoice, client, businessInfo) => {
  const doc = generateInvoicePDF(invoice, client, businessInfo);
  return doc.output('blob');
};